import fr from 'facet-rest';
import BaseOverride from 'Overrides/OnboardingStep/BaseOverride';
import CheckboxYesNo from 'Components/ComponentLibrary/Components/Uncategorized/CheckboxYesNo';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { BackwardsLozengeStat } from '../aumResponses/backwardsLozengeStat';

const AumInformationLayoutOverride = fr.metaOverride({ base: BaseOverride })
// The checkbox standardized doesn't properly handle readonly values. To limit risk, I'll use a copy that is always disabled
  .nameOverride(['prospectCurrentlyHasAum', 'prospectPlansToInvest'], { _component: () => CheckboxYesNo }, { ordinal: 1000 })
  .nameOverride('reasonProspectWillNotInvest', {
  }, { ordinal: 1000 })
  .nameOverride('debtPayOffPreference', { _component: () => BackwardsLozengeStat }, overrideReadOnly)
  .nameOverride('otherReasonProspectWillNotInvest', {
  }, { ordinal: 1000 });

export default AumInformationLayoutOverride;
